import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '../utils/translate';

export interface ResendEmailWithCodeResponse {
    status?: 'success';
    error?: string;
}

export interface ResendEmailWithCodeResult {
    success: boolean;
    translatedError?: string;
}

export const resendEmailWithCode = async (email: string): Promise<ResendEmailWithCodeResult> => {
    const { data } = await axios.post<ResendEmailWithCodeResponse>(pathfinder('reactivate'), {
        email,
        include_activation_code: true,
    });
    if (data.status === 'success') {
        return { success: true };
    } else {
        return {
            success: false,
            translatedError: data.error || translate('errors.general.unspecified'),
        };
    }
};
